import React from 'react';
import styles from './table.module.css';

const Table = () => {
  return (
    <table className={styles.table}>
      <thead className={styles.borderStyle}>
        <tr className={styles.borderStyle}>
          <th colSpan="4" className={styles.title}>هزینه بازی‌ در محوطه ها</th>
        </tr>
        <tr className={styles.borderStyle} >
          <th className={styles.tableHeader}>نوع محوطه</th>
          <th className={styles.tableHeader}>هزینه ورود به طبقه</th>
          <th className={styles.tableHeader}>هزینه ۳۰ دقیقه اول بازی</th>
          <th className={styles.tableHeader}>هزینه پس از ۳۰ دقیقه</th>
        </tr>
      </thead>
      <tbody className={styles.borderStyle}>
        <tr className={styles.borderStyle}>
          <td className={styles.tableData}>
            محوطه بازی کودکان
            (قد کودک باید زیر  ۱۲۸ سانتی‌متر  باشه)
            </td>
          <td className={styles.tableData}>۱۰,۰۰۰ تومان</td>
          <td className={styles.tableData}>۶۰,۰۰۰ تومان, وقت ورود به محوطه بازی به صورت یکجا از شارژ دستبند کم میشه</td>
          <td className={styles.tableData}>هر یک دقیقه ۲۰۰۰ تومان</td>
        </tr>
        <tr className={styles.borderStyle} >
          <td className={styles.tableData}>محوطه بازی نوجوانان و بزرگسالان
          (قد بازیکن باید بالای  ۱۲۸ سانتی‌متر باشه)
          </td>
          <td className={styles.tableData}>۱۰,۰۰۰ تومان</td>
          <td className={styles.tableData}>۱۳۵,۰۰۰ تومان, وقت ورود به محوطه بازی به صورت یکجا از شارژ دستبند کم میشه</td>
          <td className={styles.tableData}>هر یک دقیقه, ۴,۵۰۰ تومان</td>
        </tr>
      </tbody>
    </table>
  );
}

export default Table;
